import { appendALExamTemplate } from '@/functions/idp'
import RIC from './RIC_1'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
